/*
  PDP galeri düzeni: slayt yüksekliği eser+çerçeveye göre, tıklama yalnızca
  tablo alanında (el imleci), Duvarında gör butonu tablonun hemen altında ortalı.
*/
(() => {
  'use strict';

  const paintedRect = (img) => {
    const iRect = img.getBoundingClientRect();
    const w = iRect.width;
    const h = iRect.height;
    if (!w || !h || !img.naturalWidth) return iRect;
    const fit = window.getComputedStyle(img).objectFit;
    if (fit !== 'contain' && fit !== 'scale-down') return iRect;
    const scale = Math.min(w / img.naturalWidth, h / img.naturalHeight);
    const pw = img.naturalWidth * scale;
    const ph = img.naturalHeight * scale;
    return {
      left: iRect.left + (w - pw) / 2,
      top: iRect.top + (h - ph) / 2,
      right: iRect.left + (w + pw) / 2,
      bottom: iRect.top + (h + ph) / 2,
      width: pw,
      height: ph,
    };
  };

  const artBounds = (slide) => {
    const img = slide.querySelector('.product__media img');
    if (!img) return null;
    let top;
    let left;
    let right;
    let bottom;
    const painted = paintedRect(img);
    top = painted.top;
    left = painted.left;
    right = painted.right;
    bottom = painted.bottom;
    slide.querySelectorAll('.pfp-frame.is-visible, .pfp-paper.is-visible').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (!r.width) return;
      top = Math.min(top, r.top);
      left = Math.min(left, r.left);
      right = Math.max(right, r.right);
      bottom = Math.max(bottom, r.bottom);
    });
    return { top, left, right, bottom, width: right - left, height: bottom - top };
  };

  const activeSlide = (root) => {
    const slider = root.querySelector('.js-media-list');
    if (slider?.swiper?.slides?.length) {
      const idx = slider.swiper.activeIndex;
      const s = slider.swiper.slides[idx];
      if (s) return s;
    }
    return root.querySelector('.product__media-item.swiper-slide-active') || root.querySelector('.product__media-item');
  };

  const layoutGallery = () => {
    document.querySelectorAll('.product__media-list').forEach((list) => {
      if (list.closest('[data-duvar-set]')) return;
      if (list.closest('quick-add-modal, .quick-add-modal')) {
        const qvWrap = list.querySelector('.blankwall-art-button-wrap--below');
        if (qvWrap) {
          qvWrap.style.top = '';
          qvWrap.style.width = '';
          qvWrap.style.marginTop = '';
          qvWrap.style.marginLeft = '';
        }
        return;
      }
      const slide = activeSlide(list);
      if (!slide) return;

      const bounds = artBounds(slide);
      if (!bounds || !bounds.width) return;

      const listRect = list.getBoundingClientRect();
      const relTop = bounds.top - listRect.top;
      const relLeft = bounds.left - listRect.left;

      const toggle = slide.querySelector('.product__media-toggle');
      if (toggle) {
        toggle.style.top = `${relTop}px`;
        toggle.style.left = `${relLeft}px`;
        toggle.style.width = `${bounds.width}px`;
        toggle.style.height = `${bounds.height}px`;
      }

      const artBottom = relTop + bounds.height;
      slide.style.minHeight = `${artBottom}px`;
      slide.style.height = 'auto';

      const wrap = list.querySelector('.blankwall-art-button-wrap--below');
      if (wrap) {
        /*
          Konumlandırma şeması: CSS (left:50% + translateX(-50%) +
          top: calc(--pdp-media-ar)) yatayda ortalar ve ilk boyama
          öncesi yaklaşık dikey konumu verir; JS yalnızca top ve
          genişliği kesinleştirir. margin tabanlı eski şemayla
          karıştırılmamalı (çift ofset butonu görünmez yapar).
        */
        wrap.style.top = `${artBottom + 12}px`;
        wrap.style.width = `${Math.min(bounds.width, listRect.width)}px`;
        wrap.style.marginTop = '';
        wrap.style.marginLeft = '';
        list.style.minHeight = `${artBottom + 12 + (wrap.offsetHeight || 48)}px`;
      } else {
        list.style.minHeight = `${artBottom}px`;
      }
      const mediaWrap = list.closest('.product__media-wrapper');
      if (mediaWrap) {
        mediaWrap.style.minHeight = list.style.minHeight;
      }

      const slider = list.querySelector('.js-media-list');
      if (slider?.swiper && !slider.swiper.destroyed) {
        slider.swiper.update();
      }
    });
  };

  const schedule = () => {
    requestAnimationFrame(() => requestAnimationFrame(layoutGallery));
  };

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('pfp:updated', schedule);
  document.addEventListener('blankwall:ready', schedule);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }

  setTimeout(schedule, 400);
  setTimeout(schedule, 1200);

  const bindSwipers = () => {
    document.querySelectorAll('.product__media-list .js-media-list').forEach((slider) => {
      if (slider._pdpLayoutBound || !slider.swiper) return;
      slider._pdpLayoutBound = true;
      slider.swiper.on('slideChangeTransitionEnd', schedule);
      slider.swiper.on('transitionEnd', schedule);
    });
  };
  document.addEventListener('DOMContentLoaded', bindSwipers);
  setTimeout(bindSwipers, 600);
  setTimeout(bindSwipers, 1500);
})();
